export enum SyncActionType {
  TaskHeading = "Task Heading",
  TaskArrived = "Task Arrived",
  TaskDeparted = "Task Departed",
  TaskUpdate = 'Task Update'
}
